import { render, staticRenderFns } from "./FullPageLoading.vue?vue&type=template&id=74b2312d&"
import script from "./FullPageLoading.vue?vue&type=script&lang=js&"
export * from "./FullPageLoading.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports